
<template>
  <div class="about">
    <v-layout justify-center>
      <v-flex xs12 sm12>
        <v-card>
          <v-card-title>
            <h3>Worship Service Streaming</h3>
          </v-card-title>
          <v-card-subtitle>
            <strong>Streaming of Worship Service starts at 8.00 am on Sunday</strong><br>
            <span>For assistance, please email us at contact.rtl@lifertl.com</span>
          </v-card-subtitle>
          <span v-if="playerOption">
            <video-player class="vjs-custom-skin" :options="playerOption" :playsinline="true"></video-player>
          </span>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-videojs7";
export default {
  name: "VideoList",
  components: {
    videoPlayer,
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
    isMember: function () {
      return this.$store.getters.isMember;
    },
  },
  data() {
    return {
      playerOption: null,
    };
  },
  created() {
    axios.get("/api/time").then((response) => {
      let now = new Date(response.data.rfc3339);
      let day = now.getUTCDay();
      let hour = now.getUTCHours();
      if (day == 1 || (day == 0 && hour >= 11)) {
        var playerSrc =
          "https://lifertl-temp.s3-ap-southeast-1.amazonaws.com/svc9a.m3u8" +
          "?" +
          Math.round(Math.random() * 1000);
      } else {
        var playerSrc =
          "https://dr5u9t19sfw89.cloudfront.net/live/live.m3u8" +
          "?" +
          this.ident();
      }
      this.playerOption = {
        inactivityTimeout: 2000,
        liveui: true,
        fluid: true,
        sources: [
          {
            type: "application/x-mpegURL",
            src: playerSrc,
          },
        ],
        poster: "https://d1wgggc35trcty.cloudfront.net/livecopyright.jpg",
        html5: {
          hls: {
            overrideNative: true,
          },
          nativeAudioTracks: false,
          nativeVideoTracks: false,
        },
        playbackRates: [1, 1.25, 1.5, 1.75, 2],
        ready: false,
        userActive: false,
      };
    });
  },
  methods: {
    ident() {
      {
        let userObj = this.$store.getters.getUser;
        let email = "";
        if (userObj != null) {
          if (userObj.email != null) {
            email = userObj.email;
          }
        }
        return email;
      }
    },
  },
};
</script>
